import React, { useContext } from "react";
import { X } from "lucide-react";
import { Button } from "components/ui/button";
import { Context as IntlContext } from "context/Intl";
import { usePwaInstall } from "hooks/usePwaInstall";

const subtitleByMode = {
    ios: "pwa.install_banner.subtitle_ios",
    android: "pwa.install_banner.subtitle_android",
    install: "pwa.install_banner.subtitle",
} as const;

const PwaInstallBanner: React.FC = () => {
    const intl = useContext(IntlContext);
    const { isVisible, mode, install, dismiss, isInstalling } = usePwaInstall();

    if (!isVisible || mode === null) {
        return null;
    }

    const subtitleId = subtitleByMode[mode] ?? "pwa.install_banner.subtitle";

    return (
        <div
            className="flex items-center gap-3 border-b border-border/60 bg-background px-4 py-3 shadow-sm"
            role="region"
            aria-label={intl.formatMessage("pwa.install_banner.aria_label")}
        >
            <button
                type="button"
                onClick={dismiss}
                className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
                aria-label={intl.formatMessage("pwa.install_banner.close")}
            >
                <X className="h-4 w-4" aria-hidden />
            </button>

            <img
                src="/images/logo/logo-twoghether-picto-192x192.png"
                alt=""
                width={54}
                height={54}
                className="h-[54px] w-[54px] shrink-0 rounded-xl"
            />

            <div className="min-w-0 flex-1">
                <p className="m-0 text-sm font-semibold leading-5">
                    {intl.formatMessage("pwa.install_banner.title")}
                </p>
                <p className="m-0 text-xs leading-4 text-muted-foreground">
                    {intl.formatMessage(subtitleId)}
                </p>
            </div>

            {mode === "install" ? (
                <Button
                    type="button"
                    size="sm"
                    className="shrink-0"
                    onClick={install}
                    disabled={isInstalling}
                >
                    {intl.formatMessage("pwa.install_banner.install")}
                </Button>
            ) : null}
        </div>
    );
};

export default PwaInstallBanner;
